import { Alert, Card, CardBody, Table } from '@statsbomb/kitbag-components';
import PropTypes from 'prop-types';
import React, { useEffect, useState } from 'react';
import { FormattedMessage, useIntl } from 'react-intl';
import CardHeader from '../../components/CardHeader';
import CellHeadings from '../../components/CellHeadings';
import useApi, { API_ENDPOINTS } from '../../hooks/api';
import usePoll from '../../hooks/poll';
import {
  BroadcasterConnectionSummary,
  ChannelSummary,
  FullUrls,
} from './MediaDetails';

const POLL_FREQUENCY = 20000;

function FullChannelListing({ endpoint }) {
  const intl = useIntl();

  return (
    <Table.Row
      key={`${endpoint.media_package_channel?.media_live_channel?.Name}-card`}
    >
      <Table.DataCell $textAlign="left">
        {endpoint.media_package_channel?.media_live_channel?.Name}
      </Table.DataCell>
      <Table.DataCell $textAlign="left">
        <BroadcasterConnectionSummary
          endpoint={endpoint}
          messageWhenEmpty={intl.formatMessage({
            defaultMessage: 'N/A',
            description: 'N/A',
            id: '59e5b',
          })}
        />
      </Table.DataCell>
      <Table.DataCell $textAlign="left">
        <ChannelSummary endpoint={endpoint} />
      </Table.DataCell>
      <Table.DataCell $textAlign="left">
        <FullUrls endpoint={endpoint} />
      </Table.DataCell>
    </Table.Row>
  );
}

FullChannelListing.propTypes = {
  endpoint: PropTypes.shape({
    DomainName: PropTypes.string,
    media_package_channel: PropTypes.shape({
      endpoints: PropTypes.arrayOf(
        PropTypes.shape({
          Id: PropTypes.string.isRequired,
          Url: PropTypes.string.isRequired,
        }),
      ),
      media_live_channel: PropTypes.shape({
        Id: PropTypes.string,
        media_live_inputs: PropTypes.arrayOf(PropTypes.shape({})),
        Name: PropTypes.string,
        State: PropTypes.string,
      }),
    }),
  }).isRequired,
};

export function AwsStreams() {
  const api = useApi();
  const intl = useIntl();

  const [allData, setAllData] = useState([]);
  const [message, setMessage] = useState('');

  const getAllData = async () => {
    try {
      const response = await api.get(`${API_ENDPOINTS.videoService}/channels`);
      setAllData(response.data.data);
      setMessage('');
    } catch (err) {
      setMessage(
        intl.formatMessage({
          defaultMessage: 'Failing to retrieve stream data',
          description: 'Stream Data Failure',
          id: '19536',
        }),
      );
    }
  };

  useEffect(() => {
    setMessage(
      intl.formatMessage({
        defaultMessage: 'Loading Stream Data',
        description: 'Loading Stream Data',
        id: '5b70a',
      }),
    );
  }, []);

  usePoll(getAllData, POLL_FREQUENCY);

  return (
    <div>
      <Card>
        <CardHeader>
          <FormattedMessage
            defaultMessage="Full Channel Listing"
            id="fa730"
            description="Full Channel Listing table tile"
          />
        </CardHeader>
        <CardBody>
          {message && <Alert onDismiss={() => setMessage('')}>{message}</Alert>}
          <section>
            <Table size="small" aria-label="AWSStreams">
              <CellHeadings
                cells={[
                  {
                    children: intl.formatMessage({
                      defaultMessage: 'Channel Name',
                      description: 'Channel Name Title',
                      id: 'b5574',
                    }),
                    id: 'name',
                  },
                  {
                    children: intl.formatMessage({
                      defaultMessage: 'Broadcaster Connection',
                      description: 'Broadcaster Connection Title',
                      id: '0453a',
                    }),
                    id: 'connection',
                  },
                  {
                    children: intl.formatMessage({
                      defaultMessage: 'Channel Status',
                      description: 'Channel Status Title',
                      id: 'a9f2c',
                    }),
                    id: 'channel',
                  },
                  {
                    children: intl.formatMessage({
                      defaultMessage: 'Streams',
                      id: '21b3c',
                    }),
                    id: 'url-title',
                  },
                ]}
                textAlign="left"
              />
              <Table.Body>
                {allData?.length > 0 ? (
                  allData?.map((endpoint) => (
                    <FullChannelListing
                      key={`${endpoint.media_package_channel?.media_live_channel?.Name}-endpoint`}
                      endpoint={endpoint}
                    />
                  ))
                ) : (
                  <Table.Row>
                    <Table.DataCell colSpan={4}>
                      <FormattedMessage
                        defaultMessage="Streams will appear here"
                        id="b5709"
                      />
                    </Table.DataCell>
                  </Table.Row>
                )}
              </Table.Body>
            </Table>
          </section>
        </CardBody>
      </Card>
    </div>
  );
}

AwsStreams.propTypes = {};

export default AwsStreams;
